import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY || "AIzaSyAEnLgPAov2mA1IWFdVIXUEuoSLnR4WzF0",
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || "quickbudget-2b923.firebaseapp.com",
  projectId: process.env.FIREBASE_PROJECT_ID || "quickbudget-2b923",
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET || "quickbudget-2b923.firebasestorage.app",
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "882729996936",
  appId: process.env.FIREBASE_APP_ID || "1:882729996936:web:7af32fc1715a0b2d2a453d",
  measurementId: process.env.FIREBASE_MEASUREMENT_ID || "G-X64XDJBG4J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;